import { cloneElement } from 'preact';
import { memo } from 'preact/compat';
import { useEffect, useRef } from 'preact/hooks';
import { useRouter } from 'preact-router';
import ResizeObserver from 'resize-observer-polyfill';

import { updateIframeHeight } from './helpers';

const IframeView = ({ linkTarget, children, showTrailers }) => {
  const ref = useRef();
  const resizeObserver = useRef();
  const [{ matches }] = useRouter();

  useEffect(() => {
    window.iframeContext = {
      ref: ref.current,
      linkTarget: matches?.linkTarget || linkTarget || '_parent',
      showCollapsed: matches?.showCollapsed,
      showTrailers: matches?.showTrailers || showTrailers,
    };
  }, [matches?.linkTarget, matches?.showCollapsed, matches?.showTrailers, linkTarget, showTrailers]);

  useEffect(() => {
    if (ref.current.base && !resizeObserver.current) {
      const observer = new ResizeObserver(() => updateIframeHeight(ref.current));

      observer.observe(ref.current.base);
      resizeObserver.current = observer;
    }

    return () => {
      if (resizeObserver.current) {
        resizeObserver.current.disconnect();
        resizeObserver.current = null;
      }
    };
  }, [ref.current?.base]);

  useEffect(() => {
    const iframeMessageHandler = (event) => {
      if (event?.data?.action === 'getHeight') {
        updateIframeHeight(ref.current);
      }
    };

    window.addEventListener('message', iframeMessageHandler);
    return () => {
      window.removeEventListener('message', iframeMessageHandler);
    };
  }, []);

  return cloneElement(children, { ref });
};

export default memo(IframeView);
